export const getDashboardSummaryQuery = (params = {}) => {
    const {
      propertyIds = [],
      startDate = "",
      endDate = ""
    } = params;

      const filters = [
        `propertyIds:${JSON.stringify(propertyIds)}`,
        `startDate:${JSON.stringify(startDate)}`,
        `endDate:${JSON.stringify(endDate)}`
    ];
    const query = `
    query{
        dashboardSummary(
          ${filters.join('\n          ')}
        ){
          payments{
            thisMonth
            billedThisMonth
            percentagePaid
          }
          units{
            vacant
            occupied
            percentageOccupied
          }
          arrears{
            unit
            tenant
            amount
            tenantId
          }
          countUnassignedPayments
          unpaidTenantsCount
          overpaidTenantsCount
          unpaidTenantsAmount
          overpaidTenantsAmount
        }
      }`

    return query
  }